import {ButtonColor} from '@common/ui/buttons/get-shared-button-style';
import {useSettings} from '@common/core/settings/use-settings';
import {useNavigate} from '@common/utils/hooks/use-navigate';
import {Menu, MenuTrigger} from '@common/ui/navigation/menu/menu-trigger';
import {IconButton} from '@common/ui/buttons/icon-button';
import {PersonIcon} from '@common/icons/material/Person';
import {Item} from '@common/ui/forms/listbox/item';
import {Trans} from '@common/i18n/trans';
import {Link} from 'react-router-dom';
import {Button} from '@common/ui/buttons/button';
import {NavbarProps} from '@common/ui/navigation/navbar/navbar';
import {Fragment} from 'react';

interface NavbarAuthButtonsProps {
  primaryButtonColor?: ButtonColor;
  navbarColor?: NavbarProps['color'];
}
export function NavbarAuthButtons({
  primaryButtonColor,
  navbarColor,
}: NavbarAuthButtonsProps) {
  if (!primaryButtonColor) {
    primaryButtonColor = navbarColor === 'primary' ? 'paper' : 'primary';
  }

  return (
    <Fragment>
      <MobileButtons />
      <DesktopButtons primaryButtonColor={primaryButtonColor} />
    </Fragment>
  );
}

interface DesktopButtonsProps {
  primaryButtonColor: ButtonColor;
}
function DesktopButtons({primaryButtonColor}: DesktopButtonsProps) {
  const {registration} = useSettings();
  const registrationSettings = registration || {disable: false};
  return (
    <div className="hidden lg:flex login-btn-div">
      <a href="/login" className="btn btn-primary btn-sm py-2 px-9 login-btn">
        <Trans message="Log In" />
      </a>
      {!registrationSettings.disable && (
        <a href="/register" className="btn btn-primary-outline btn-sm py-2 px-9 get-st-btn">
          <Trans message="Get Started" />
        </a>
      )}
    </div>
  );
}

function MobileButtons() {
  const {registration} = useSettings();
  const registrationSettings = registration || {disable: false};
  return (
    <div className="flex lg:hidden flex-col">
      <a href="/login" className="btn btn-primary btn-sm py-2 px-9 w-100 login-btn">
        <Trans message="Log In" />
      </a>
      {!registrationSettings.disable && (
        <a href="/register" className="btn btn-primary-outline btn-sm py-2 px-9 w-100 get-st-btn mt-3">
          <Trans message="Get Started" />
        </a>
      )}
    </div>
  );
}
